import {h, Fragment} from "preact";

const Else = ({children}) => <Fragment >{children}</Fragment>

export default Else;
